"use strict";

var base = require("../product/base");
var focusHelper = require("../components/focus");
const constants = require("../helpers/const");
const { initProductThumbnails } = require("../product/productThumbnails");
const { formSubmitEvents, pageViewEvent, viewCartEvent, cartEvents } = require("../helpers/gtmHelpers");
const { handleGiftCardValidation, initGiftCardEvents} = require("../giftCard");
const { appendToUrl } = require("../utils/urlUtils");
const { handleRemovedGivexNotification } = require("../checkout/givexClient");
const { invalid } = require("../components/clientSideValidation");
const { addToWishlist, updateHeaderIconState } = require("../product/wishlistHeart");
const { showAddedToWishlistConfirmation } = require("../helpers/wishlistConfirmation");
const { updateOrderSummary } = require("../components/orderSummary");
const { initExpressStickyBar } = require("./expressStickyBar");
const { lg } = require("../breakpoints").globalBreakpoints;
const accessibleDialog = require("../helpers/accessibleDialog");
const klarnaPlacement = require("../components/klarnaMessaging");

// How long the edit drawer takes to slide out; matches the transition in
// components/_mobileQuickViewModal.scss.
const EDIT_DRAWER_TRANSITION_MS = 500;

// UUID of the line whose edit drawer is open, so focus can go back to its edit link on close
let editDrawerLineItemUuid = null;

// Options the open drawer was registered with in the accessible dialog helper, which keeps a
// reference to them; returnFocusTo is re-pointed when Update re-renders the line (DGF-4872)
let editDrawerDialogOptions = null;

/**
 * Enables or disables every way of starting checkout from the bag: the checkout CTA and the
 * express wallets.
 *
 * The CTA is a link, so the class alone doesn't stop it: the attributes keep it out of the tab
 * order and announce it as disabled, and the delegated handler in the module export blocks
 * activation. The wallets are hidden rather than disabled because they are SDK-rendered and can't
 * be reliably disabled from outside. Not the PDP's own wallets (express-section--pdp): they pay for
 * the product on the page, not the basket, and this module runs on every page (components/miniCart.js). cart/expressPayments.isml renders them with the same class for
 * a basket that is already invalid, so fixing the basket (removing the line) reveals them here; the
 * cart:update that follows makes cartWallets re-mount them into the now-visible container.
 * @param {boolean} disabled - whether checkout should be disabled
 */
function setCheckoutActionsDisabled(disabled) {
    $(".checkout-btn")
        .toggleClass("disabled", disabled)
        .attr({
            "aria-disabled": disabled ? "true" : "false",
            tabindex: disabled ? "-1" : "0"
        });
    $(".express-section:not(.express-section--pdp)").toggleClass("express-section--basket-invalid", disabled);
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            // DGF-4835: same markup as the server-rendered message in cart/cart.isml, and replaced
            // rather than appended, so repeated updates don't stack copies. Only this message is
            // replaced: .cart-error also holds createErrorNotification's (coupon, quantity, ...).
            $(".cart-error .cart-validation-error").remove();
            $(".cart-error").append(
                $("<div class=\"valid-cart-error cart-validation-error\" role=\"alert\"></div>").text(data.valid.message)
            );
        } else {
            $(".cart").empty().append("<div class=\"row\"> " +
                "<div class=\"col-12 text-center\"> " +
                "<h1>" + data.resources.emptyCartMsg + "</h1> " +
                "</div> " +
                "</div>"
            );
            $(".number-of-items").empty().append(data.resources.numberOfItems);
            $(".minicart-quantity").empty().append(data.numItems);
            $(".minicart-link").attr({
                "aria-label": data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $(".minicart .popover").empty();
            $(".minicart .popover").removeClass("show");
        }

        setCheckoutActionsDisabled(true);
    } else {
        $(".cart-error .cart-validation-error").remove();
        setCheckoutActionsDisabled(false);
    }
}

/**
 * DGF-4877: gives the bag's Klarna placement the new total.
 * @param {Object|null|undefined} klarnaMessaging - CartModel.klarnaMessaging; undefined leaves it as it is
 */
function updateKlarnaMessaging(klarnaMessaging) {
    if (klarnaMessaging !== undefined) {
        klarnaPlacement.updatePlacement("basket", klarnaMessaging ? klarnaMessaging.purchaseAmount : 0);
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    const $grandTotal = $(".grand-total");
    const $subTotal = $(".sub-total");

    $(".number-of-items").empty().append(data.resources.numberOfItems);
    $(".shipping-cost").empty().append(data.totals.totalShippingCost);
    $(".tax-total").empty().append(data.totals.totalTax);
    $(".delivery-cost-total").empty().append(data.totals.deliveryTotalCost);
    $(".minicart-quantity").empty().append(data.numItems);
    updateOrderSummary(data.totals);
    $(".minicart-link").attr({
        "aria-label": data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    $subTotal.empty();
    $grandTotal.empty();

    // DGF-5012: same choice as cart/grandTotalValue.isml and checkout/cart/miniCart.isml, so totals don't change on update.
    if (data.customerCreditApplied) {
        $(".credits-applied-amount").empty().append(`-${data.customerCreditApplied.formatted}`);
        $grandTotal.append(data.totals.deliveryTotalCostNotFormatted !== "-" ? data.totals.grandTotalAdjusted : data.totals.grandTotalAdjustedWithoutShipping);
        $subTotal.append(data.totals.grandTotalAdjustedWithoutShipping);
    } else {
        $grandTotal.append(data.totals.deliveryTotalCostNotFormatted !== "-" ? data.totals.grandTotal : data.totals.totalWithoutShipping);
        $subTotal.append(data.totals.totalWithoutShipping);
    }

    updateKlarnaMessaging(data.klarnaMessaging);

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $(".shipping-discount").removeClass("hide-shipping-discount");
        $(".shipping-discount-total").empty().append("- " +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $(".shipping-discount").addClass("hide-shipping-discount");
    }

    if (!data.action?.toLowerCase().includes("coupon")) {
        $(".gift-cards-wrapper").empty();
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $(".item-" + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $(".item-" + item.UUID).empty();
        }
        $(".uuid-" + item.UUID + " .unit-price").empty().append(item.renderedPrice);
        $(".line-item-price-" + item.UUID + " .unit-price").empty().append(item.renderedPrice);
        $(".item-total-" + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
        "fade show\" role=\"alert\">" +
        "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
        "<span aria-hidden=\"true\">&times;</span>" +
        "</button>" + message + "</div>";

    $(".cart-error").append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = "";
    $(".approaching-discounts").empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            if (item.discountMsg) {
                html += "<div class=\"single-approaching-discount\">"
                + item.discountMsg + "</div>";
            }
        });
    }
    $(".approaching-discounts").append(html);
}

/**
 * DGF-4863: refreshes the delivery box (cart/deliveryBox.isml) in the mini bag and basket after an AJAX update.
 * The message can carry markup from the promotion's discountMsg, as approaching discount messages do.
 * @param {Object|null} deliveryBox - the cart model's deliveryBox; null when the box is switched off or the
 *     basket is now empty, which hides it
 */
function updateDeliveryBox(deliveryBox) {
    var $boxes = $(".delivery-box");
    if (!deliveryBox) {
        $boxes.addClass("d-none");
        return;
    }
    $boxes.toggleClass("d-none", !deliveryBox.show)
        .toggleClass("delivery-box--qualified", !!deliveryBox.qualified);
    $boxes.find(".delivery-box__threshold").toggleClass("d-none", !deliveryBox.showThreshold);
    $boxes.find(".delivery-box__message").html(deliveryBox.message);
    $boxes.find(".delivery-box__bar").attr("value", deliveryBox.percent);
    $boxes.find(".delivery-box__arrival").toggleClass("d-none", !deliveryBox.arrival).html(deliveryBox.arrival || "");
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = "";

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $(".availability-" + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += "<p class=\"line-item-attributes\">" + message + "</p>";
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += "<p class=\"line-item-attributes line-item-instock-date\">"
                    + lineItem.availability.inStockDate
                    + "</p>";
            }
        }

        $(".availability-" + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $(".card.product-info.uuid-" + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Whether the edit modal is shown as the PLP Quick View drawer rather than a centred modal.
 *
 * @returns {boolean} true when the edit modal is the drawer
 */
function isEditDrawer() {
    return $("#editProductModal").hasClass("mobile-quick-view-modal");
}

/**
 * Selector for a basket line's edit link.
 *
 * @param {string} uuid - the line item UUID
 * @returns {string} the selector
 */
function editLinkSelector(uuid) {
    return ".uuid-" + uuid + " .product-edit .edit";
}

/**
 * Slides the edit drawer out, then hides it, as the PLP Quick View does.
 *
 * @param {jQuery} $modal - the edit drawer
 */
function hideEditDrawerPanel($modal) {
    $modal.removeClass("open");
    setTimeout(function () {
        // Skipped if a newly opened drawer has replaced this one in the meantime: hiding the old one
        // would take the new one's backdrop and scroll lock with it
        if (document.body.contains($modal[0])) {
            $modal.modal("hide");
        }
    }, EDIT_DRAWER_TRANSITION_MS);
}

/**
 * Closes the edit modal.
 *
 * The drawer is closed through the accessible dialog helper, which un-inerts the bag and returns
 * focus, then slides the drawer out through onClose. The helper returns false when the drawer was
 * never opened through it - closed while its content was still loading - so it is hidden directly.
 * A close during Bootstrap's 0.5s opening transition, which ignores hide, is also remembered and
 * carried out on shown.bs.modal instead of opening the helper (DGF-4872).
 */
function closeEditProductModal() {
    var $modal = $("#editProductModal");

    if (!isEditDrawer()) {
        $modal.modal("hide");
        return;
    }

    if (!accessibleDialog.close($modal)) {
        $modal.data("closeRequested", true);
        hideEditDrawerPanel($modal);
    }
}

/**
 * Applies the WAI-ARIA modal dialog pattern to the edit drawer once it is on screen.
 *
 * The drawer is not a .modal, so the site-wide Bootstrap enhancement (accessibleDialog
 * enhanceBootstrapModals) does not reach it. As with the PLP Quick View drawer, Bootstrap shows it
 * with focus and keyboard off, and the helper owns focus, the tab trap, Escape and inerting the bag
 * behind it (DGF-4872).
 */
function openEditDrawerDialog() {
    editDrawerDialogOptions = {
        initialFocus: ".modal-header .close",
        returnFocusTo: editDrawerLineItemUuid ? editLinkSelector(editDrawerLineItemUuid) : null,
        onClose: function (dialog) {
            hideEditDrawerPanel($(dialog));
        }
    };

    accessibleDialog.open($("#editProductModal"), editDrawerDialogOptions);
}

/**
 * Generates the modal window on the first call.
 *
 * Below the lg breakpoint it is built as the PLP Quick View drawer (product/quickView.js), which
 * slides up from the bottom of the screen; the content is the same product/quickView template.
 * The drawer's close button has no data-dismiss so it can slide out first (DGF-4872).
 */
function getModalHtmlElement() {
    var $existingModal = $("#editProductModal");
    if ($existingModal.length !== 0) {
        // A drawer reopened within its 0.5s slide-out is removed before its own hide runs, and that
        // hide is what removes its backdrop; release the helper and drop the backdrop with it
        if (accessibleDialog.isOpen($existingModal)) {
            accessibleDialog.close($existingModal);
        }
        $existingModal.remove();
        $(".modal-backdrop").remove();
    }
    var isDrawer = window.innerWidth < lg;
    var modalAttributes = isDrawer
        ? "class=\"fade custom-modal mobile-quick-view-modal quick-view-modal\" tabindex=\"-1\""
        : "class=\"modal fade custom-modal quick-view-modal\"";
    var htmlString = "<!-- Modal -->"
        + "<div " + modalAttributes + " id=\"editProductModal\" role=\"dialog\">"
        + "<div class=\"modal-dialog modal-dialog-centered quick-view-dialog\">"
        + "<!-- Modal content-->"
        + "<div class=\"modal-content\">"
        + "<div class=\"modal-header\">"
        + "    <button type=\"button\" class=\"close pull-right\"" + (isDrawer ? "" : " data-dismiss=\"modal\"") + ">"
        + "        " + constants.ModalIcons.closeSvg
        + "    </button>"
        + "</div>"
        + "<div class=\"modal-body\"></div>"
        + "</div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".product-quickview");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $.ajax({
        url: editProductUrl,
        method: "GET",
        dataType: "json",
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);
            const editProductModalBody = $("#editProductModal .modal-body");
            editProductModalBody.html(parsedHtml.body);
            $(".pdp-slider").slick();
            $(window).trigger("resize");
            $("body").trigger("quickview:ready");
            $(".pdp-slider").slick("setPosition");
            // The drawer's outer element is not fixed like a .modal: it sits at the end of the page,
            // so Bootstrap focusing it scrolls the page to the footer. Focus and Escape are left to
            // the accessible dialog helper instead (openEditDrawerDialog), as on the PLP (DGF-4872).
            if (isEditDrawer()) {
                $("#editProductModal").modal({ focus: false, keyboard: false });
            } else {
                $("#editProductModal").modal("show");
            }

            const $renderUncachedDataWrapper = editProductModalBody.find(".renderUncachedData-wrapper");
            if ($renderUncachedDataWrapper.length) {
                const remoteincludeurl = $renderUncachedDataWrapper.data("remoteincludeurl");
                $.ajax({
                    url: remoteincludeurl,
                    method: "GET",
                    success: function (renderedData) {
                        $renderUncachedDataWrapper.html(renderedData);
                        $(".swatch-slider").slick();
                        $(".full-pdp-link").removeClass("d-none");

                        // The drawer slides in once its content is complete, as on the PLP
                        $("#editProductModal.mobile-quick-view-modal").addClass("open");

                        // check Notify-me-form for invalid fields in Edit modal on the Cart page after modal is rendered
                        invalid();
                    },
                    error: function () {
                        // Slide the drawer in regardless, so its close button is reachable rather
                        // than the bag sitting under a backdrop with nothing on screen
                        $("#editProductModal.mobile-quick-view-modal").addClass("open");
                    }
                });
            } else {
                $("#editProductModal.mobile-quick-view-modal").addClass("open");
            }
        }
    });
}

/**
 * Removes a line from the basket through Cart-RemoveProductLineItem and updates the page: used by
 * the remove confirmation and by "Save to wishlist" (DGF-4872).
 *
 * @param {string} url - the remove URL, with the line's pid and uuid appended
 * @param {string} uuid - the line item UUID
 */
function removeProductLineItem(url, uuid) {
    $.spinner().start();

    $("body").trigger("cart:beforeUpdate");

    $.ajax({
        url: url,
        type: "get",
        dataType: "json",
        success: function (data) {
            cartEvents(data.removeFromCartDataLayer);

            if (data.basket.items.length === 0) {
                $(".cart").empty();
                $(".empty-cart-container").removeClass("d-none");
                $(".number-of-items").empty().append(data.basket.resources.numberOfItems);
                $(".minicart-quantity").empty().append(data.basket.numItems);
                $(".minicart-link").attr({
                    "aria-label": data.basket.resources.minicartCountOfItems,
                    title: data.basket.resources.minicartCountOfItems
                });
                $(".minicart .popover").empty();
                $(".minicart .popover").removeClass("show");
                $("body").removeClass("modal-open");
                $("html").removeClass("veiled");
            } else {
                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $(".uuid-" + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
                $(".uuid-" + uuid).remove();
                if (!data.basket.hasBonusProduct) {
                    $(".bonus-product").remove();
                }
                $(".coupons-and-promos").empty().append(data.basket.totals.discountsHtml);
                updateCartTotals(data.basket);
                updateApproachingDiscounts(data.basket.approachingDiscounts);
                updateDeliveryBox(data.basket.deliveryBox);
                $("body").trigger("setShippingMethodSelection", data.basket);
                validateBasket(data.basket);
            }

            $("body").trigger("cart:update", data);

            $.spinner().stop();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $(".cart-delete-confirmation-btn");
    var $productToRemoveSpan = $(".product-to-remove");

    $deleteConfirmBtn.data("pid", productID);
    $deleteConfirmBtn.data("action", actionUrl);
    $deleteConfirmBtn.data("uuid", uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
* Handles the notification for the removal of Givex cards on page load.
* This function checks for a specific data attribute to determine if a modal
* should be shown and triggers a custom event accordingly.
*
* @fires givex:removed - Triggers a custom event with details about the modal display
* @returns {void}
*/
function handleGivexRemovedNotificationOnPageLoad() {
    const container = document.getElementById("givexRemovedDataContainer");
    const showRemovedGivexCardsModal = container?.getAttribute("data-is-show") === "true";

    if (!showRemovedGivexCardsModal) return;

    $("body").trigger("givex:removed", { showRemovedGivexCardsModal: showRemovedGivexCardsModal });
}

module.exports = function () {
    // DGF-4835: a disabled checkout link must not navigate. pointer-events: none (_buttons.scss)
    // stops mouse clicks, but not Enter/Space from a keyboard or assistive technology.
    $("body").on("click keydown", ".checkout-btn.disabled", function (e) {
        if (e.type === "click" || e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
    });

    if ($(".cart-page").length || $(".cart-empty").length) {
        pageViewEvent("Cart");
        viewCartEvent();
    }

    $(document).on("click", ".size-chart-modal", function (e) {
        e.stopPropagation();
    });

    // Close inner modal when its close button is clicked
    $(document).on("click", ".size-chart-close", function () {
        $(".size-chart-modal").modal("hide");
    });

    $("body").on("quickview:ready", function () {
        if ($(".pdp-slider").hasClass("slick-initialized")) {
            initProductThumbnails();
        }
    });

    $("body").on("click", ".remove-product", function (e) {
        e.preventDefault();

        var actionUrl = $(this).data("action");
        var productID = $(this).data("pid");
        var productName = $(this).data("name");
        var uuid = $(this).data("uuid");
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $("body").on("afterRemoveFromCart", function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $("body").on("click", ".cart-delete-confirmation-btn", function (e) {
        e.preventDefault();

        var productID = $(this).data("pid");
        var url = $(this).data("action");
        var uuid = $(this).data("uuid");
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        removeProductLineItem(url, uuid);
    });

    // DGF-4872: "Save to wishlist" saves the product to the wishlist (Cart-SaveForLater, which
    // never toggles it off), then removes the line exactly as the remove button does
    $("body").on("click", ".line-item-save-for-later-link", function (e) {
        e.preventDefault();

        var $link = $(this);
        var $removeButton = $link.closest(".product-info").find(".remove-product").first();
        var uuid = $removeButton.data("uuid");
        var removeUrl = appendToUrl($removeButton.data("action"), {
            pid: $removeButton.data("pid"),
            uuid: uuid
        });
        var form = { pid: $link.attr("data-pid") };
        form[$link.data("tokenName")] = $link.data("token");

        $.spinner().start();

        $.ajax({
            url: $link.data("url"),
            type: "post",
            dataType: "json",
            data: form,
            success: function (data) {
                if (!data.success) {
                    $.spinner().stop();
                    createErrorNotification(data.errorMessage);
                    return;
                }

                if (data.gtmObject) {
                    cartEvents(data.gtmObject);
                }
                updateHeaderIconState(false);
                if (data.showWishlistModal) {
                    showAddedToWishlistConfirmation();
                }

                removeProductLineItem(removeUrl, uuid);
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification((err.responseJSON && err.responseJSON.errorMessage) || $link.data("errorMessage"));
                    $.spinner().stop();
                }
            }
        });
    });

    $("body").on("change", ".quantity-form > .quantity", function () {
        var preSelectQty = $(this).data("pre-select-qty");
        var quantity = $(this).val();
        var productID = $(this).data("pid");
        var url = $(this).data("action");
        var uuid = $(this).data("uuid");

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents(".card").spinner().start();

        $("body").trigger("cart:beforeUpdate");

        $.ajax({
            url: url,
            type: "get",
            context: this,
            dataType: "json",
            success: function (data) {
                $(".quantity[data-uuid=\"" + uuid + "\"]").val(quantity);
                $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateDeliveryBox(data.deliveryBox);
                updateAvailability(data, uuid);
                validateBasket(data);
                const gtmData = $(this).data("pre-select-qty") < quantity ? data.addToCartDataLayer : data.removeFromCartDataLayer;
                cartEvents(gtmData);
                $(this).data("pre-select-qty", quantity);

                $("body").trigger("cart:update", data);

                $.spinner().stop();
                if ($(this).parents(".product-info").hasClass("bonus-product-line-item") && $(".cart-page").length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $(".shippingMethods").change(function () {
        var url = $(this).attr("data-actionUrl");
        var urlParams = {
            methodID: $(this).find(":selected").attr("data-shipping-id")
        };
        // url = appendToUrl(url, urlParams);

        $(".totals").spinner().start();
        $("body").trigger("cart:beforeShippingMethodSelected");
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateDeliveryBox(data.deliveryBox);
                    validateBasket(data);
                }

                $("body").trigger("cart:shippingMethodSelected", data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $("body").on("click", ".cart-page .promo-code-toggle", function () {
        var isExpanded = $(this).attr("aria-expanded") === "true";
        var $couponCodeField = $(".promo-code-form .coupon-code-field");

        $(this).attr("aria-expanded", String(!isExpanded));
        $(".cart-page .promo-code-form").prop("hidden", isExpanded);

        // Clear any error left from an earlier attempt so it never names a code no longer in the field
        $couponCodeField.removeClass("is-invalid").removeAttr("aria-describedby");
        $(".coupon-missing-error").hide();
        $(".coupon-error-message").empty();

        if (!isExpanded) {
            $(".cart-page .coupon-code-field").trigger("focus");
        }
    });

    $(".cart-page .promo-code-form").submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $(".coupon-missing-error").hide();
        $(".coupon-error-message").empty();
        if (!$(".coupon-code-field").val().trim()) {
            $(".promo-code-form .form-control").addClass("is-invalid");
            $(".promo-code-form .form-control").attr("aria-describedby", "missingCouponCode");
            $(".coupon-missing-error").show();
            $.spinner().stop();
            return false;
        }
        var $form = $(".promo-code-form");
        $(".promo-code-form .form-control").removeClass("is-invalid");
        $(".coupon-error-message").empty();
        $("body").trigger("promotion:beforeUpdate");

        $.ajax({
            url: $form.attr("action"),
            type: "GET",
            dataType: "json",
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $(".promo-code-form .form-control").addClass("is-invalid");
                    $(".promo-code-form .form-control").attr("aria-describedby", "invalidCouponCode");
                    $(".coupon-error-message").empty().append(data.errorMessage);
                    $("body").trigger("promotion:error", data);
                } else {
                    $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateDeliveryBox(data.deliveryBox);
                    validateBasket(data);
                    $("body").trigger("promotion:success", data);

                    if (data.removeCouponTooltipMarkup) {
                        $(".bag-tooltip").empty().append(data.removeCouponTooltipMarkup);
                    }

                    formSubmitEvents("Cart promo code form");
                }
                $(".coupon-code-field").val("");
                $.spinner().stop();
            },
            error: function (err) {
                $("body").trigger("promotion:error", err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $("body").on("click", ".cart-page .remove-coupon", function (e) {
        e.preventDefault();

        var couponCode = $(this).data("code");
        var uuid = $(this).data("uuid");
        var $deleteConfirmBtn = $(".delete-coupon-confirmation-btn");
        var $productToRemoveSpan = $(".coupon-to-remove");

        $deleteConfirmBtn.data("uuid", uuid);
        $deleteConfirmBtn.data("code", couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $("body").on("click", ".cart-page .delete-coupon-confirmation-btn", function (e) {
        e.preventDefault();

        var url = $(this).data("action");
        var uuid = $(this).data("uuid");
        var couponCode = $(this).data("code");
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        const tooltipContent = $(".bag-tooltip").html();

        url = appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        $.spinner().start();
        $("body").trigger("promotion:beforeUpdate");
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                $(".coupon-uuid-" + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateDeliveryBox(data.deliveryBox);
                validateBasket(data);
                $.spinner().stop();
                $(".bag-tooltip").html(tooltipContent);
                $("body").trigger("promotion:success", data);
            },
            error: function (err) {
                $("body").trigger("promotion:error", err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $("body").on("click", ".cart-page .bonus-product-button", function () {
        $.spinner().start();
        $(this).addClass("launched-modal");
        $.ajax({
            url: $(this).data("url"),
            method: "GET",
            dataType: "json",
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
        $("#chooseBonusProductModal").remove();
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");

        if ($(".cart-page").length) {
            $(".launched-modal .btn-outline-primary").trigger("focus");
            $(".launched-modal").removeClass("launched-modal");
        } else {
            $(".product-detail .add-to-cart").focus();
        }
    });

    $("body").on("click", ".cart-page .product-edit .edit, .cart-page .bundle-edit .edit", function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr("href");
        getModalHtmlElement();
        editDrawerLineItemUuid = $(this).closest(".product-info").find(".remove-product").attr("data-uuid") || null;

        // The drawer shows the PLP Quick View image carousel rather than the PDP one (DGF-4872)
        if (isEditDrawer()) {
            editProductUrl = appendToUrl(editProductUrl, { isQuickView: true });
        }

        fillModalElement(editProductUrl);
    });

    $("body").on("click", "#editProductModal.mobile-quick-view-modal .close", function () {
        closeEditProductModal();
    });

    $("body").on("click", ".modal-backdrop", function () {
        if (isEditDrawer() && $("#editProductModal").hasClass("show")) {
            closeEditProductModal();
        }
    });

    $(document).on("shown.bs.modal", "#editProductModal", function () {
        setTimeout(function () {
            $(".pdp-slider").slick("setPosition");
            $(".product-thumbnails-list").trigger("resize");
        }, 0);

        initGiftCardEvents();
    });

    $("body").on("shown.bs.modal", "#editProductModal", function () {
        // The drawer's background is hidden by the accessible dialog helper, which records and later
        // restores the page's own aria-hidden state; setting it here first would be what it restores
        if (isEditDrawer()) {
            // Closed while it was still opening: hide it now, rather than inerting the bag behind a
            // drawer that is on its way out
            if ($("#editProductModal").data("closeRequested")) {
                $("#editProductModal").modal("hide");
                return;
            }

            openEditDrawerDialog();
            return;
        }

        $("#editProductModal").siblings().attr("aria-hidden", "true");
    });

    $("body").on("hidden.bs.modal", "#editProductModal", function () {
        // Safety net: never leave the bag inert behind a drawer that has gone. onClose then calls
        // hide on the already-hidden modal, which Bootstrap ignores.
        if (accessibleDialog.isOpen(this)) {
            accessibleDialog.close(this);
        }

        if (!isEditDrawer()) {
            $("#editProductModal").siblings().attr("aria-hidden", "false");
        }

        editDrawerLineItemUuid = null;
        editDrawerDialogOptions = null;
    });

    // With keyboard: false, Bootstrap answers Escape inside the drawer with its static-backdrop
    // "bounce", which ends by focusing the drawer's outer element - at the foot of the page - and
    // scrolls the bag there, straight after the helper has closed the drawer and returned focus.
    // Cancelling hidePrevented stops it before that focus (DGF-4872).
    $("body").on("hidePrevented.bs.modal", "#editProductModal", function (e) {
        if (isEditDrawer()) {
            e.preventDefault();
        }
    });

    $("body").on("keydown", "#editProductModal", function (e) {
        // The drawer's tab trap is the accessible dialog helper's
        if (isEditDrawer()) {
            return;
        }

        var focusParams = {
            event: e,
            containerSelector: "#editProductModal",
            firstElementSelector: ".close",
            lastElementSelector: ".update-cart-product-global",
            nextToLastElementSelector: ".modal-footer .quantity-select"
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $("body").on("product:updateAddToCart", function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");

        $(".update-cart-product-global", dialog).attr("disabled",
            !$(".global-availability", dialog).data("ready-to-order")
            || !$(".global-availability", dialog).data("available")
        );
    });

    $("body").on("product:updateAvailability", function (e, response) {
        // bundle individual products
        $(".product-availability", response.$productContainer)
            .data("ready-to-order", response.product.readyToOrder)
            .data("available", response.product.available)
            .find(".availability-msg")
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");

        if ($(".product-availability", dialog).length) {
            // bundle all products
            var allAvailable = $(".product-availability", dialog).toArray()
                .every(function (item) { return $(item).data("available"); });

            var allReady = $(".product-availability", dialog).toArray()
                .every(function (item) { return $(item).data("ready-to-order"); });

            $(".global-availability", dialog)
                .data("ready-to-order", allReady)
                .data("available", allAvailable);

            $(".global-availability .availability-msg", dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $(".global-availability", dialog)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available)
                .find(".availability-msg")
                .empty()
                .html(response.message);
        }
    });

    $("body").on("product:afterAttributeSelect", function (e, response) {
        base.methods.displaySizeError(false);
        $(".custom-product-size-button.disabled").removeClass("error");
        if ($(".modal.show .product-quickview .bundle-items").length) {
            $(".modal.show").find(response.container).data("pid", response.data.product.id);
            $(".modal.show").find(response.container).find(".product-id").text(response.data.product.id);
        } else {
            $(".modal.show .product-quickview").data("pid", response.data.product.id);
        }

        base.handleLowStockIndicator(response?.container, response?.data?.product?.lowStockIndicatorInfo);
    });

    $("body").on("change", ".quantity-select", function () {
        var selectedQuantity = $(this).val();
        $(".modal.show .update-cart-url").data("selected-quantity", selectedQuantity);
    });

    $("body").on("change", ".options-select", function () {
        var selectedOptionValueId = $(this).children("option:selected").data("value-id");
        $(".modal.show .update-cart-url").data("selected-option", selectedOptionValueId);
    });

    $("body").on("click", ".update-cart-product-global", function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest(".cart-and-ipay").find(".update-cart-url").val();
        var selectedQuantity = $(this).closest(".cart-and-ipay").find(".update-cart-url").data("selected-quantity");
        var selectedOptionValueId = $(this).closest(".cart-and-ipay").find(".update-cart-url").data("selected-option");
        var uuid = $(this).closest(".cart-and-ipay").find(".update-cart-url").data("uuid");
        const giftCardWrapper = $(".gift-card-wrapper");

        if ($(".custom-product-size-button").length && $(".custom-product-size-button.selected").length === 0 && !$(".gc-amount-field").length) {
            base.methods.displaySizeError(true);
            return;
        }

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        if (giftCardWrapper.length) {
            if (!handleGiftCardValidation()) {
                return;
            }
            form.selectedGiftPrice = Number($(".gift-card-wrapper").find(".gc-amount").val());
        }

        $(this).parents(".card").spinner().start();

        $("body").trigger("cart:beforeUpdate");

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: "post",
                context: this,
                data: form,
                dataType: "json",
                success: function (data) {
                    $(".coupons-and-promos").empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateDeliveryBox(data.cartModel.deliveryBox);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $(".uuid-" + data.uuidToBeDeleted).remove();
                    }

                    // The edited line can come back under a new UUID, so focus returns to the
                    // re-rendered line's edit link. Closed after the re-render so that link exists.
                    var updatedUuid = $("<div>").append($.parseHTML(data.renderedTemplate))
                        .find(".remove-product").first().attr("data-uuid");
                    if (editDrawerDialogOptions && updatedUuid) {
                        editDrawerDialogOptions.returnFocusTo = editLinkSelector(updatedUuid);
                    }
                    closeEditProductModal();

                    validateBasket(data.cartModel);

                    $("body").trigger("cart:update", data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    // custom event handler for the givex removal notification modal
    $("body").on("givex:removed", (event, data) => {
        const container = document.getElementById("givexRemovedDataContainer");
        const url = container?.getAttribute("data-givex-removed-modal-url");

        if (!url) return;

        $.ajax({
            url: url,
            method: "GET",
            dataType: "json",
            success: (responseObj) => {
                if (responseObj?.renderedTemplate && !$("#givexRemovedNotificationModal").length) {
                    $(".page").append(responseObj.renderedTemplate);
                }

                handleRemovedGivexNotification(data?.showRemovedGivexCardsModal);

                const $promoFormControlEl = $(".promo-code-form-wrapper .form-control");
                const $couponMissingErrorEl = $(".coupon-missing-error");
                const $couponErrMessageEl = $(".coupon-error-message");

                if (
                    !$promoFormControlEl.length ||
                    !$couponMissingErrorEl.length ||
                    !$couponErrMessageEl.length
                ) return;

                $promoFormControlEl.removeClass("is-invalid");
                $couponMissingErrorEl.hide();
                $couponErrMessageEl.empty();
            }
        });
    });

    $("body").on("promotion:success", (event, responseData) => {
        // handle gift card removal on promotion success custom event
        if (responseData?.showRemovedGivexCardsModal) {
            $("body").trigger("givex:removed", { showRemovedGivexCardsModal: responseData.showRemovedGivexCardsModal });
        }
    });

    handleGivexRemovedNotificationOnPageLoad();
    addToWishlist();
    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    base.callInitGiftCardEvents();
    base.notifyMe();
    base.handleOneSizeProductLowStockIndicator();
    // DGF-4614. Safe to run before the wallets have mounted: it only wires the observer that fades the
    // bar out over the bag's own checkout block. Whether the bar is visible at all is the express
    // client's business, through setSurfaceVisibility.
    initExpressStickyBar();
};
